import { Injectable } from '@angular/core';
import gsap from 'gsap';

@Injectable({
  providedIn: 'root',
})
export class IntroPageAnimation {
  public animation: GSAPTimeline;

  constructor() {}

  public play(
    onCompleteCallback: () => void,
    animateContent: boolean = true,
    isLandscape: boolean,
  ) {
    const onComplete = () => setTimeout(() => onCompleteCallback(), 500);

    this.animation = gsap.timeline({ onComplete });

    if (isLandscape) {
      this.animation
        .add(() => {
          if (animateContent) {
            return gsap.to(['.black-overlay', '.content-wrapper'], {
              ease: 'power2.out',
              autoAlpha: 0,
              duration: 1.5,
            });
          }
        }, 0)
        .to(
          ['.c01-tv-frame', 'img.hisense-tv-frame'],
          {
            ease: 'power2.out',
            scale: 1,
            duration: 2,
          },
          1,
        )
        .to(
          'img.intro-background-landscape',
          {
            ease: 'power2.out',
            scale: 2.25,
            transformOrigin: '50% 25%',
            duration: 2,
          },
          1,
        );
    } else {
      this.animation.add(
        gsap.to(['.black-overlay', '.content-wrapper'], {
          ease: 'power2.out',
          autoAlpha: 0,
          duration: 1.5,
        }),
      );
    }
  }
}
